import styled from 'styled-components';
import { lighten } from 'polished';
import { DropdownButton as DropdownSource } from 'react-bootstrap';

const DropdownButton = styled(DropdownSource)`
    background-color: #fafafa !important;
    background-image: none;
    border: 1px solid ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primary} !important;
    text-shadow: none;
    padding: 10px;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,0.30);

    :hover {
        background-color: ${props => lighten(0.1, props.theme.colors.primary)} !important;
        color: #fff !important;
        outline: none !important;

        ::before {
            background-color: #fff;
            color: ${props => props.theme.colors.primary};
        }
    }

    ::before{
        display: inline-block;
        width: 20px;
        font-size: 17px;
        line-height: 22px;
        background-color: ${props => props.theme.colors.primary};
        border-radius: 20px;
        font-weight: bold;
        content: "+";
        color: #FFF;
        margin-right: 10px;
    }
`;

export default DropdownButton;



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/DropdownButton.js